/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const komboIntegrationTypeSchema = z.enum(['ATS', 'HRIS'])

export type KomboIntegrationTypeSchema = z.infer<typeof komboIntegrationTypeSchema>
